/*
 * Copyright (c) 2020. Legalbird eine Marke der R&S Internet Jewels GmbH
 */

import React from "react";
import FormFader from "../../Common/Fader/FormFader";
import Paper from "@mui/material/Paper";
import Grid from "@mui/material/Grid";
import FormSubmit from "../../Common/FormSubmit/FormSubmit";
import FamilyIcon from "../../../../assets/icons/generic/toggleable/IconFamilyDetailed";
import StrollerIcon from "../../../../assets/icons/familyLaw/toggleable/IconStroller";
import QuestionMarkIcon from "../../../../assets/icons/common/toggleable/IconQuestionmark";
import Hidden from "@mui/material/Hidden";
import { useForm } from "../../../../provider/Form/FormProvider";
import Group from "../../../Wizard/Group";
import { requiredValidator } from "../../../../services/validationRules";
import Typography from "@mui/material/Typography";
import FormSubmitProps from "../../../../types/FormSubmitProps";
import wizardStyle from "../../wizardStyle";
import { Box } from "@mui/material";

type AlimonyChoiceProps = { submitProps: FormSubmitProps };

export default function AlimonyChoice({ submitProps }: AlimonyChoiceProps) {
  const { handleSubmit } = useForm();

  return (
    <Paper sx={wizardStyle.paper} elevation={4}>
      <FormFader>
        <Box component={"form"} sx={{ ...wizardStyle.applicationForm, ...wizardStyle.wizardForm }} onSubmit={handleSubmit}>
          <Hidden smUp>
            <Typography variant={"h4"} sx={wizardStyle.headline}>
              Meine Analyse
            </Typography>
          </Hidden>
          <Grid container justifyContent={"center"}>
            <Grid item xs={12}>
              <Group
                type="radio"
                name="basicChoice"
                question="Wie können wir Ihnen weiterhelfen?"
                options={[
                  {
                    labelText: "Ehegattenunterhalt und Kindesunterhalt berechnen",
                    labelIcon: <FamilyIcon />,
                    labelIconActive: <FamilyIcon active />,
                    value: "complete",
                    optionHintText:
                      "Ich befinde mich in einer Trennungssituation von meinem Ehepartner und möchte wissen, wer an wen Unterhalt zahlen muss und wie viel.",
                  },
                  {
                    labelText: "Nur Kindesunterhalt berechnen",
                    labelIcon: <StrollerIcon />,
                    labelIconActive: <StrollerIcon active />,
                    value: "children",
                    optionHintText: "Ich war nie mit meinem Ex-Partner verheiratet, möchte aber wissen, wer Kindesunterhalt zahlen muss und wie viel.",
                  },
                  {
                    labelText: "Andere Frage im Bereich Unterhalt",
                    labelIcon: <QuestionMarkIcon />,
                    labelIconActive: <QuestionMarkIcon active />,
                    value: "other",
                    optionHintText: "Ich benötige keine Berechnung, sondern habe ein anderes Anliegen.",
                  },
                ]}
                validators={[requiredValidator("Bitte wählen Sie eine der angezeigten Antworten aus")]}
              />
            </Grid>
          </Grid>
          <FormSubmit {...submitProps} />
        </Box>
      </FormFader>
    </Paper>
  );
}
